import React from 'react'
import { Col, Modal, Row } from 'react-bootstrap'
import Table from './Table'
import Spinner from '../header/Spinner'
function ActionsAndPopups(props) {
  const {
    isPopSelected,
    editFieldName,
    handleLoadMore,
    displayLoadMore,
    inputmodel,
    handleCancelClick,
    handleSaveClick,
    okButtonDisabled,
    showEditPopup,
    sendPop,
    personsLIst,
    deleteFunction,
    onAddingItem,
    editFunction,
    isLoading,
    dropdownselectfunction,
    applyFunction,
    dropdownselect,
    checkedArray,
    selectedStatus,
    approvePerson,
    ApproveOptionPermission,
    EDitOptionPermission,
    DeleteOptionPermission,
    BulkActionPermission,
  } = props
  return (
    <>
      <Col md={6} xs={12}></Col>
      <div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <div>
            <Row>
              <Col md={6} xs={12} /* style={{ display: 'flex', gap: '10px' }} */></Col>
            </Row>
          </div>
          <div style={{ display: 'flex' }}></div>
          {BulkActionPermission && checkedArray.length > 0 && (
            <>
              <div style={{ display: 'flex', gap: '10px' }}>
                <div style={{ marginTop: '3px' }}>
                  <label style={{ marginTop: '5px' }} htmlFor='languages'>
                    Bulk Actions:
                  </label>
                  <div>
                    <select required name='select' id='languages' onChange={dropdownselectfunction}>
                      <option value='' disabled selected>
                        Bulk Actions
                      </option>
                      {props.status === 'published' ? '' : <option value='published'>publish</option>}
                      <option value='send to draft'>Draft</option>
                      <option value='Delete' name='chechboxdelete'>
                        Delete
                      </option>
                    </select>
                  </div>
                    </div>
                  <div style={{ marginTop: '35px' }}>
                    <button
                      className='btn btn-primary'
                      type='button'
                      disabled={!(dropdownselect !== '')}
                      onClick={() => applyFunction()}
                    >
                      Apply
                    </button>
                  </div>
              </div>
            </>
          )}

          {isLoading && <Spinner />}
          {personsLIst.length > 0 ? (
            <Table
              personsObjectData={personsLIst}
              editFunction={editFunction}
              onAddingItem={onAddingItem}
              deleteFunction={deleteFunction}
              status={selectedStatus}
              approvePerson={approvePerson}
              ApproveOptionPermission={ApproveOptionPermission}
              EDitOptionPermission={EDitOptionPermission}
              DeleteOptionPermission={DeleteOptionPermission}
            />
          ) : (
            'No Data Found'
          )}
        </div>
        {isPopSelected && (
          <Modal
            show={showEditPopup}
            /* fullscreen={'md-down'} */ dialogClassName='modal-90w'
            onHide={() => sendPop(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title>{editFieldName}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{inputmodel}</Modal.Body>
            <Modal.Footer>
              <div style={{ display: 'flex', gap: '10px' }}>
                <button className=' btn btn-primary' onClick={handleCancelClick}>
                  Cancel
                </button>
                <button
                  className=' btn btn-primary'
                  onClick={handleSaveClick}
                  disabled={!okButtonDisabled}
                >
                  Ok
                </button>
              </div>
            </Modal.Footer>
          </Modal>
        )}
        <div className='d-grid mt-3 mb-5'>
          {displayLoadMore && (
            <button
              style={{ width: '15%' }}
              onClick={() => handleLoadMore(true)}
              type='button'
              className='btn btn-primary'
            >
              Load More
            </button>
          )}
        </div>
      </div>
    </>
  )
}

export default ActionsAndPopups
